import React from "react";
import { Box, Grid, Typography, OutlinedInput } from "@mui/material";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { FiMapPin } from "react-icons/fi";

interface BillingContact {
  name: string;
  email: string;
  phone: string;
  address: string;
}

interface BillingContactFormProps {
  contact: BillingContact;
  setContact: (contact: BillingContact) => void;
}

const BillingContactForm: React.FC<BillingContactFormProps> = ({ contact, setContact }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Typography
            sx={{
              fontFamily: "Manrope",
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "20px",
              color: "#0055A4",
              mb: 0.75,
            }}
          >
            Billing Contact Name <span style={{ color: "#D92D20" }}>*</span>
          </Typography>
          <OutlinedInput
            fullWidth
            value={contact.name}
            onChange={(e) => setContact({ ...contact, name: e.target.value })}
            placeholder="John Doe"
            sx={{
              height: "40px",
              fontFamily: "Manrope",
              fontSize: "16px",
              "& .MuiOutlinedInput-input": {
                padding: "8px 12px",
              },
            }}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography
            sx={{
              fontFamily: "Manrope",
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "20px",
              color: "#0055A4",
              mb: 0.75,
            }}
          >
            Email <span style={{ color: "#D92D20" }}>*</span>
          </Typography>
          <OutlinedInput
            fullWidth
            type="email"
            value={contact.email}
            onChange={(e) => setContact({ ...contact, email: e.target.value })}
            placeholder="doe@abcdoelog.com"
            sx={{
              height: "40px",
              fontFamily: "Manrope",
              fontSize: "16px",
              "& .MuiOutlinedInput-input": {
                padding: "8px 12px",
              },
            }}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography
            sx={{
              fontFamily: "Manrope",
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "20px",
              color: "#0055A4",
              mb: 0.75,
            }}
          >
            Phone number <span style={{ color: "#D92D20" }}>*</span>
          </Typography>
          <Box
            sx={{
              "& .PhoneInput": {
                height: "40px",
                border: "1px solid #D0D5DD",
                borderRadius: "4px",
                padding: "0 12px",
                display: "flex",
                alignItems: "center",
                fontFamily: "Manrope",
                fontSize: "16px",
              },
              "& .PhoneInputInput": {
                border: "none",
                outline: "none",
                fontFamily: "Manrope",
                fontSize: "16px",
              },
            }}
          >
            <PhoneInput
              international
              defaultCountry="AU"
              value={contact.phone}
              onChange={(value) => setContact({ ...contact, phone: value || "" })}
              placeholder="+61 3 3333 3333"
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Typography
            sx={{
              fontFamily: "Manrope",
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "20px",
              color: "#0055A4",
              mb: 0.75,
            }}
          >
            Address <span style={{ color: "#D92D20" }}>*</span>
          </Typography>
          <Box sx={{ position: "relative" }}>
            <OutlinedInput
              fullWidth
              value={contact.address}
              onChange={(e) => setContact({ ...contact, address: e.target.value })}
              placeholder="42 Wallaby Way, Sydney"
              endAdornment={
                <FiMapPin
                  style={{
                    fontSize: "20px",
                    color: "#667085",
                  }}
                />
              }
              sx={{
                height: "40px",
                fontFamily: "Manrope",
                fontSize: "16px",
                "& .MuiOutlinedInput-input": {
                  padding: "8px 12px",
                },
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BillingContactForm;